/// <amd-module name="VSSUI/Components/PeoplePicker/PeoplePickerUtils" />
import { IPersonaSharedProps as IPersonaProps } from "OfficeFabric/Persona";
import { IIdentity } from "../PeoplePicker/SharedPeoplePicker.Props";
import { PersonaSize } from "OfficeFabric/Persona";

/** @deprecated */
export function convertIdentityToPersona(identity: IIdentity | undefined): IPersonaProps {
    return {
        imageUrl: identity.image,
        text: identity.displayName,
        showSecondaryText: !!identity.displayName && identity.displayName !== "",
        secondaryText: getSignInAddress(identity),
        size: PersonaSize.extraExtraSmall
    };
}

/** @deprecated */
export function convertIdentityListToPersonaList(entities: IIdentity[] | PromiseLike<IIdentity[]>): IPersonaProps[] | PromiseLike<IPersonaProps[]> {
    const suggestionsArray: IIdentity[] = entities as IIdentity[];
    const suggestionsPromiseLike: PromiseLike<IIdentity[]> = entities as PromiseLike<IIdentity[]>;
    if (Array.isArray(suggestionsArray)) {
        return suggestionsArray.map(x => convertIdentityToPersona(x));
    } else if (suggestionsPromiseLike && suggestionsPromiseLike.then) {
        return suggestionsPromiseLike.then(results => results.map(x => convertIdentityToPersona(x)));
    } else {
        return null;
    }
}

/** @deprecated */
export function getSignInAddress(identity: IIdentity): string {
    if (!identity.isHosted && identity.samAccountName && identity.samAccountName.trim()) {
        return (identity.scopeName && identity.scopeName.trim() ? identity.scopeName + "\\" : "") + identity.samAccountName;
    }
    return identity.signInAddress && identity.signInAddress.trim()
        ? identity.signInAddress
        : identity.mail && identity.mail.trim()
        ? identity.mail
        : identity.mailNickname && identity.mailNickname.trim()
        ? identity.mailNickname
        : "";
}

/** @deprecated */
export function isUser(identity: IIdentity): boolean {
    return identity.entityType.toLocaleLowerCase() === "user";
}
